import {inject, Injectable, signal} from '@angular/core';
import {NotificationService} from "./notification/notification.service";
import {StorageService} from "./storage.service";
import {UserService} from "./user.service";
import {ParamMap} from "@angular/router";
import {ReferredByDialogComponent} from "./referral/referred-by-dialog/referred-by-dialog.component";
import {ThreeForThreeDialogComponent} from "../components/three-for-three-dialog/three-for-three-dialog.component";

export interface ExternalCode {
  type: 'referral' | '3-for-3';
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExternalCodeService {
  private readonly notificationService = inject(NotificationService);
  private readonly storageService = inject(StorageService);
  private readonly userService = inject(UserService);

  constructor() {
    this.getSavedCode().then(code => {
      this.savedCode.set(code);
    });
  }

  private lastCode: string | undefined;
  public async updateQueryParams(queryParams: ParamMap) {
    const referralCode = queryParams.get('referralCode');
    const unpaidCode = queryParams.get('uCode');

    let code: ExternalCode | undefined;

    if ((this.userService.user()?.status == 'unauthorized' || this.userService.user()?.status == 'signup-flow')) {
      if (unpaidCode) {
        code = {type: '3-for-3', code: unpaidCode};
      } else if (referralCode) {
        code = {type: 'referral', code: referralCode};
      }
    }

    if (code) {
      await this.storageService.setItem("EXTERNAL_CODE", code);
      this.savedCode.set(code);

      if (this.lastCode !== code.code) {
        this.lastCode = code.code;
        if (code.type === 'referral') {
          this.userService.getNameByReferralCode(code.code).subscribe(
            (name) => {
              this.notificationService.openNotificationDialog(
                [
                  {component: ReferredByDialogComponent, data: {name: name}}
                ]
              )
            }
          )
        }
        else
          if (code.type === '3-for-3') {
            this.notificationService.openNotificationDialog([{
              component: ThreeForThreeDialogComponent,
              data: {type: '3-for-3'}
            }]);
          }
        }
      }
  }

  public async getSavedCode() {
    return await this.storageService.getItem("EXTERNAL_CODE");
  }

  public savedCode = signal<ExternalCode | undefined>(undefined);
}
